const config = {
    env: import.meta.env.VITE_ENV,
    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
    sentryEnv: import.meta.env.VITE_SENTRY_ENV,
    verion: import.meta.env.VITE_VERSION,
    apiUrl: import.meta.env.VITE_API_URL,
    rmsApiUrl: import.meta.env.VITE_RMS_API_URL,
    apiRefUrl: import.meta.env.VITE_API_REFERENCE_URL,
    froalaKey: import.meta.env.VITE_FROALA_ACTIVATION_KEY,
    mixPanelKey: import.meta.env.VITE_MIXPANEL_TOKEN,
    mixPanelOFF: import.meta.env.VITE_MIXPANEL_OFF === 'true',
    emailLogoMaxSize: 2000000, // 2mb
    appcuesAccountId: import.meta.env.VITE_APPCUES_ACCOUNT_ID,
    canduClientToken: import.meta.env.VITE_CANDU_CLIENT_TOKEN,
};

export default config;
